<template>
  <div class="index">
    <!-- <div class="box"></div> -->
    <div class="over_h ovDiv">
      <iframe scrolling="auto" style="height:90vh;border:none" width="100%" src="https://www.aliyun.com/solution/govcloud/ai-pig"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      open:true,
      exit:false,
      fullscreen: false
    }
  },
  methods:{

  },
  // 注册组件
  components: {

  },
  created() {

  },
}
</script>

<style scoped>
  .box{
    height:20px
  }

</style>



// WEBPACK FOOTER //
// src/views/pdaList/aiStatistics.vue